import { buildProxyConfigShape } from '../base.js';
import { managementAppProxyApi } from './management-app.js';
export * from './management-app.js';
export const customPageProxyApis = [managementAppProxyApi];
export const customPageProxyConfigShape = buildProxyConfigShape(customPageProxyApis);
